<template>
	<div v-if="isLicenseManagerAvailable && canViewWorkbook" class="sheet-details-outter">
		<p-container
			orientation="vertical"
			:lastExpandedSize="70"
			sizeUnits="px"
			:lastMaxSize="50"
			maxSizeUnits="%">
			<div
				slot="last"
				:class="{
					'sheet-view-footer': true,
					'raise-config':
						configuratorProps && // When the timeline/gantt configurator is open, we want the footer to render above
						!loading &&
						!loadingRecords &&
						!shouldShowWizard, // Except when we are loading, or in any type of wizard
				}">
				<view-footer-root
					:dataStore="sheetGlobalState.dataStore"
					:selectedSheetViewGUID="sheetViewGUID" />
			</div>
			<p-container
				orientation="horizontal"
				:firstExpandedSize="350"
				:firstMouseResize="true"
				:firstMaxSize="50"
				:firstStyle="{
					boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)'
				}"
				maxSizeUnits="%">
				<div class="sheet-view-body">
					<p-container
						orientation="vertical"
						:lastMaxSize="showExportBottomBar ? 32 : 0"
						maxSizeUnits="px">
						<component
							:is="bodyComponent"
							v-if="activeSheetView"
							:sheetView="activeSheetView"
							:loadingRecords="loadingRecords"
							:loadedRecords="loadedRecords"
							:key="dataStoreGUID" />
						<export-bottom-bar
							v-if="showExportBottomBar && activeSheetView"
							slot="last"
							:sheetView="activeSheetView"
							@hook:mounted="exportBottomBarMounted"
							@hook:beforeDestroy="exportBottomBarBeforeDestroy"
						/>
					</p-container>
				</div>
				<sheet-view-sidebar
					v-if="!!sidebarTab"
					:tab="sidebarTab"
					slot="first"
					@onChangeTab="sidebarTab = $event"/>
			</p-container>
		</p-container>
		<sheet-wizard-renderer
			v-if="
				(sheetGlobalState.dataStore && activeSheetView && shouldShowWizard && !globalModalIsOpen) ||
				(!sheetGlobalState.dataStore && queryNew && !globalModalIsOpen)
			"
			:loading="queryNew && !sheetGlobalState.dataStore"
			:dataStore="sheetGlobalState.dataStore || null"
			:sheetView="activeSheetView || null"
			@hook:mounted="sheetWizardRendererMounted = true"
		/>
		<sheet-wizard-conductor
			v-if="
				sheetGlobalState.dataStore &&
				activeSheetView &&
				shouldShowWizard &&
				sheetWizardRendererMounted &&
				!globalModalIsOpen
			"
			:dataStore="sheetGlobalState.dataStore"
			:sheetView="activeSheetView"
		/>
		<!--     <reactive-references
    	namespace="sheetView"
    ></reactive-references>    -->
		<r-standard-dynamic-modal modalName="sheetView" />
		<r-standard-dynamic-modal-filler
			v-if="
				configuratorProps && !loading && !loadingRecords && !shouldShowWizard
			"
			linkedModalName="sheetView"
			:dynamicComponent="ConfiguratorContainerModalComponent"
			:passedProps="{
				sheetView: configuratorProps.sheetView,
				initialTab: configuratorProps.initialTab,
				tabFlow: configuratorProps.tabFlow,
				fixProblem: configuratorProps.fixProblem
					? configuratorProps.fixProblem
					: false,
			}"
			:modalOptions="{
				closeOnShroudClick: false,
				marginBottomPX: 70,
				showHomeEscape: true,
			}"
			@closeModal="configuratorProps = null"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-if="canvasHelperProps"
			linkedModalName="sheetView"
			:dynamicComponent="TimelineRecordModalComponent"
			:passedProps="{
				record: canvasHelperProps.record,
				sheetView: canvasHelperProps.sheetView,
			}"
			@closeModal="canvasHelperProps = null"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-if="welcomeGuideHelperProps"
			linkedModalName="sheetView"
			:dynamicComponent="WelcomeGuideHelperModalComponent"
			:passedProps="{
				dataStore: welcomeGuideHelperProps.dataStore,
				message: welcomeGuideHelperProps.message,
			}"
			@closeModal="closeWelcomeHelper"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-else-if="versionHistoryModalProps"
			linkedModalName="sheetView"
			:dynamicComponent="VersionHistoryModal"
			:passedProps="versionHistoryModalProps"
			@closeModal="versionHistoryModalProps = null"
		>
		</r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-else-if="embedModalProps"
			linkedModalName="sheetView"
			:dynamicComponent="EmbedModalComponent"
			:passedProps="{
				dataStore: embedModalProps.dataStore,
				sheetView: embedModalProps.sheetView,
			}"
			@closeModal="embedModalProps = null"
		>
		</r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal modalName="sheetViewFields" />
		<r-standard-dynamic-modal-filler
			v-if="newColumnProps"
			linkedModalName="sheetViewFields"
			:dynamicComponent="NewColumndModalComponent"
			:passedProps="newColumnProps"
			:modalOptions="{
				closeOnShroudClick: false,
			}"
			@closeModal="newColumnProps = null"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-else-if="dropdownOptionsProps"
			linkedModalName="sheetViewFields"
			:dynamicComponent="DropdownOptionsModalComponent"
			:passedProps="{
				sheetView: dropdownOptionsProps.sheetView,
				fieldGUID: dropdownOptionsProps.fieldGUID,
			}"
			@closeModal="closeDropdownOptionsModal"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-else-if="integrationManagementProps"
			linkedModalName="sheetViewFields"
			:dynamicComponent="IntegrationManagementModal"
			:passedProps="integrationManagementProps"
			:modalOptions="{
				closeOnShroudClick: false,
				modalInnerStyle: {
					borderRadius: '4px'
				}
			}"
			@closeModal="integrationManagementProps = null" />
		<r-standard-dynamic-modal-filler
			v-else-if="filterColumnModalProps"
			linkedModalName="sheetViewFields"
			:dynamicComponent="FilterColumnsModalComponent"
			:passedProps="filterColumnModalProps"
			@closeModal="filterColumnModalProps = null"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-else-if="primaryColumnModalProps"
			linkedModalName="sheetViewFields"
			:dynamicComponent="PrimaryColumnModalComponent"
			:passedProps="primaryColumnModalProps"
			@closeModal="primaryColumnModalProps = null"
		></r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-if="clearWorkbookModalOpen"
			linkedModalName="sheetViewFields"
			:dynamicComponent="clearTableModalComponent"
			:passedProps="{
				sheetView: activeSheetView
			}"
			@closeModal="clearWorkbookModalOpen = false" />
		<r-standard-dynamic-modal-filler
			v-if="accessControlModalProps"
			linkedModalName="sheetViewFields"
			:dynamicComponent="AccessControlModal"
			:passedProps="accessControlModalProps"
			@closeModal="accessControlModalProps = null" />
		<r-standard-dynamic-modal-filler
			v-if="importModalType"
			linkedModalName="sheetViewFields"
			:dynamicComponent="importDataModalComponent"
			:passedProps="{
				sheetView: activeSheetView,
				importType: importModalType,
			}"
			@closeModal="importModalType = null" />
		<canvas
			id="rv-confetti-canvas"
			class="fs-hide"
			style="
				display: none;
				position: fixed;
				pointer-events: none;
				top: 0px;
				width: 100vw;
				height: 100vh;
			"
			:height="`${windowHeight}px`"
			:width="`${windowWidth}px`"
		></canvas>
		<global-state-aggregator-oro
			:dataStore="sheetGlobalState.dataStore" />
		<global-state-aggregator-wom
			:dataStore="sheetGlobalState.dataStore" />
	</div>
	<div class="no-permission-outter" v-else>
		<r-shadow v-if="isLicenseManagerAvailable" class="no-permission-container">
			<template
				v-if="failedLoading"
			>
				<div class="no-permission-title p-typography-dark-18">Workbook cannot load</div>
				<div class="no-permission-body p-typography-regular-14">
					You may have access in another workspace, or the URL could be wrong.
					Try switching to another workspace and reopening this link. Or check that the URL is correct. 
				</div>
			</template>
			<template
				v-else
			>
				<div class="no-permission-title p-typography-dark-18">Please request view access</div>
				<div class="no-permission-body p-typography-regular-14">
					Your Visor account does not have access to view this Workbook.
					Please request view access from the document owner, then reload
					this page.
				</div>
			</template>
		</r-shadow>
	</div>
</template>
<script>
import ViewFooterRoot from 'vue/sheet-views/common/view-footer-root.vue'
import CloudStore from 'js/cloudstore/cloudstore';
import CommonVueFunctions from 'vue/sheet-views/common/common-vue-functions';
import BackgroundBus from 'js/bus/background-bus';
import ReactiveVueObject from 'js/vue-support/reactive-vue-object';
import ConnectedApps from 'js/connected-apps/connected-apps';
import OnboardingUtils from 'js/education/onboarding-utils.js';
import ReactiveReferences from 'vue/utils/reactive-references.vue';
import TimelineRecordModal from 'vue/sheet-views/data-table/timeline-record-modal.vue';
import WelcomeGuideHelperModal from 'vue/sheet-views/common/welcome-guide-helper-modal.vue';
import NewColumnModal from 'vue/sheet-views/common/fields/new-column-modal.vue';
import DropdownOptionsModal from 'vue/sheet-views/common/fields/dropdown-options-modal.vue';
import FilterColumnsModal from 'vue/sheet-views/common/fields/filter-columns-modal.vue';
import VersionHistoryModal from 'vue/sheet-views/common/version-history/version-history-modal.vue';
import AccessControlModal from "vue/share/access-control-modal.vue";
import AbstractPicklistController from 'js/data-store/abstract-picklist-controller';
import ConfiguratorContainerModal from 'vue/sheet-views/common/configurator/configurator-container-modal.vue';
import PrimaryColumnModal from 'vue/sheet-views/common/fields/primary-column-modal.vue';
import IntegrationManagementModal from "vue/sheet-views/common/integration-management/integration-management-modal.vue";
import DataStoreFieldDetailsCacheMixin from 'js/data-store/data-store-field-details-cache-mixin';

import ClearTableModal from "vue/sheet-views/common/clear-table-modal.vue";
import ImportDataModal from "vue/sheet-views/common/import-data-modal.vue";
import EmbedModal from "vue/sheet-views/common/embed-modal.vue";

import SheetDetailsActions from "js/actions/sheet-details-actions";

import GlobalStateAggregatorOro from "vue/sheet-views/common/global-state-aggregators/global-state-aggregator-oro.vue";
import GlobalStateAggregatorWom from "vue/sheet-views/common/global-state-aggregators/global-state-aggregator-wom.vue";

const vueComponentsByType = {
	table: {
		body(resolve) {
			return import(/* webpackChunkName: "sheet-view-table-body" */ 'vue/sheet-views/data-table/table-body-main.vue');
		},
	},
	timeline: {
		body(resolve) {
			return import(/* webpackChunkName: "sheet-view-timeline-body" */ 'vue/sheet-views/timeline/timeline-body-main.vue');
		},
	},
	gantt: {
		body(resolve) {
			return import(/* webpackChunkName: "sheet-view-gantt-body" */ 'vue/sheet-views/gantt/gantt-body-main.vue');
		},
	},
}

export default {
	$pubsub: {
		sharing: {
			subscriptions: {
				/**
				 * Open the sharing modal
				 * @param {Object} currentDataStore Handle to the root datastore to base the share modal off of
				 */
				openModal({dataStore, onCloseCallback}) {
					this.accessControlModalProps = {
						state: {},
						dataStore, // Passthrough the user information object,
						onCloseCallback
					}
				}
			}
		},
		exporting: {
			subscriptions: {
				preVisualExport({ callback }) {
					this.showExportBottomBar = true;
					this.exportBottomBarMountCallback = callback;
				},
				postVisualExport() {
					this.showExportBottomBar = false;
				}
			}
		},
		workbook: {
			subscriptions: {
				showVersionHistoryModal(versionHistoryModalProps) {
					this.versionHistoryModalProps = versionHistoryModalProps;
				},
				showClearWorkbookModal() {
					this.clearWorkbookModalOpen = true;
				},
				toggleWorkbookSidebar({ tabName }) {
					if (this.sidebarTab !== tabName) {
						this.sidebarTab = tabName;
					} else {
						this.sidebarTab = null;
					}
				}
			}
		},
		workbookState: {},
		sheetViews: {
			subscriptions: {
				// THE BELOW FUNCTION IS DEPRECATED!!!!!!!!!!!!!!!!!!
				sheetViewSelected({ selectedSheetView }) { // This is now deprecated, since this is in sheet-details-actions as "changeSheetView" and is implemented with undo/redo
					const vcSelf = this;

					// console.log(`sheetViewSelected`)
					// vcSelf.$router.push(`/sheets/${vcSelf.dataStoreGUID}/${selectedSheetView.$internals.metaProperties.meta.guid}`);

					vcSelf.$router.push({
						name: 'sheet-details-view',
						params: {
							dataStoreGUID: vcSelf.dataStoreGUID,
							sheetViewGUID: selectedSheetView.$internals.metaProperties.meta.guid,
						}
					});
				},
				firstSheetViewMounted({ sheetView }) {

					const vcSelf = this;

					// console.log(`firstSheetViewMounted`)

					vcSelf.firstSheetView = sheetView;
					//This is responsible for selecting the first sheet on load
					if (!vcSelf.sheetViewGUID) {
						// console.log("B");
						vcSelf.$router.replace({
							name: 'sheet-details-view',
							params: {
								dataStoreGUID: vcSelf.dataStoreGUID,
								sheetViewGUID: sheetView.$internals.metaProperties.meta.guid
							}
						});
					}
				},
				firstSheetViewChanged({ sheetView }) {

					const vcSelf = this;

					// console.log(`firstSheetViewChanged`)

					vcSelf.firstSheetView = sheetView;
					//This is responsible for selecting the first sheet on load
					if (!vcSelf.sheetViewGUID) {
						// console.log("C");
						vcSelf.$router.replace({
							name: 'sheet-details-view',
							params: {
								dataStoreGUID: vcSelf.dataStoreGUID,
								sheetViewGUID: sheetView.$internals.metaProperties.meta.guid
							}
						});
					}
				}
			}
		},
		oros: {},
		canvasRecordModal: {
			subscriptions: {
				openModal({ record, sheetView }) {
					this.canvasHelperProps = {
						record,
						sheetView,
					};
				}
			}
		},
		wizardProgressBar: {
			subscriptions: {
				updateState(progressBarDetails) {
					this.sheetGlobalState.wizard.progressBar.currentState = progressBarDetails;
				}
			}
		},
		welcomeGuideHelperModal: {
			subscriptions: {
				openModal({ dataStore, message, onClose }) {
					this.welcomeGuideHelperProps = {
						dataStore,
						message,
						onClose,
					};
				}
			}
		},
		newColumnModal: {
			subscriptions: {
				openModal(props) {
					this.newColumnProps = {
						sheetView: props.sheetView,
					};
					if (props.overrideObject) {
						this.newColumnProps.overrideObject = props.overrideObject;
					}
				}
			}
		},
		dropdownOptionsModal: {
			subscriptions: {
				openModal({ sheetView, fieldGUID }) {
					this.dropdownOptionsProps = {
						sheetView,
						fieldGUID,
					};
				}
			}
		},
		ganttTableColumns: {
			subscriptions: {
				triggerAddColumn({ sheetView, overrideObject }) {
					this.filterColumnModalProps = {
						sheetView,
						overrideObject
					};
				}
			}
		},
		nestingLevelEditor: {
			subscriptions: {
				editNestingLevels() {
					this.configuratorProps = {
						sheetView: this.activeSheetView,
						initialTab: "levelsShown",
						tabFlow: false,
					};
				}
			}
		},
		plottedDataEditor: {
			subscriptions: {
				editPlottedData() {
					this.configuratorProps = {
						sheetView: this.activeSheetView,
						initialTab: "plottedData",
						tabFlow: false,
					};
				}
			}
		},
		resolutionPicker: {
			subscriptions: {
				editResolution() {
					this.configuratorProps = {
						sheetView: this.activeSheetView,
						initialTab: "timeframe",
						tabFlow: false,
					};
				}
			}
		},
		primaryColumn: {
			subscriptions: {
				openPrimaryColumnModal({ dataStore, sheetView }) {
					this.primaryColumnModalProps = {
						dataStore,
						sheetView,
					};
				},
				closeModal() {
					this.primaryColumnModalProps = null;
				},
			},
		},
		dataImport: {
			subscriptions: {
				openModal({ importType }) {
					this.importModalType = importType;
				},
			},
		},
		embedModal:{
			subscriptions: {
				openModal({dataStore, sheetView}){
					this.embedModalProps = {
						sheetView,
						dataStore
					}
				}
			}
		}
	},
	data() {
		return {
			getFieldCacheCallbacks: [],
			orosPublished: [],
			loading: true,
			loadingRecords: true,
			failedLoading: false,
			loadedRecords: [],
			firstSheetView: null,
			sheetGlobalState: {
				dataStore: null,
				dataStoreRecordsByLevels: null,
				picklistController: AbstractPicklistController,
				wizard: {
					progressBar: {
						currentState: null,
					},
				},
				ConnectedApps,
			},
			canvasHelperProps: null,
			welcomeGuideHelperProps: null,
			newColumnProps: null,
			dropdownOptionsProps: null,
			filterColumnModalProps: null,
			versionHistoryModalProps: null,
			accessControlModalProps: null,
			configuratorProps: null,
			primaryColumnModalProps: null,
			integrationManagementProps: null,
			sheetWizardRendererMounted: false,
			sharedSheetState: new ReactiveVueObject(),
			clearWorkbookModalOpen: false,
			importModalType: null,
			embedModalProps: null,
			showExportBottomBar: false,
			sidebarTab: null
		};
	},
	mixins: [
		new DataStoreFieldDetailsCacheMixin(),
	],
	created() {
		BackgroundBus.pub("ActiveWorkbook", "fieldCacheAvailable", this.fieldCache);
	},
	mounted() {
		window.sheetDetails = this;
		this.$pubsub.modules.actions.pub("setActions", {
			availableActions: SheetDetailsActions
		});
		this.loadingRecords = false;
	},
	provide() {
		return {
			sheetGlobalState: this.sheetGlobalState,
			workbookHasPermission: this.workbookHasPermission,
			sharedSheetState: this.sharedSheetState,
		};
	},
	beforeDestroy() {
		this.$pubsub.modules.workbookState.pub('stateChanged', null);
		BackgroundBus.pub("ActiveWorkbook", "fieldCacheUnavailable");
		BackgroundBus.pub("ActiveWorkbook", "dataStoreUnavailable");
		BackgroundBus.pub("ActiveWorkbook", "dataStoreRecordsByLevelUnavailable");
		BackgroundBus.pub("ActiveWorkbook", "sheetViewUnavailable");
		BackgroundBus.pub("ActiveWorkbook", "workbookUnavailable");
	},
	watch: {
		loadingRecords(newState) {
			if (!!newState) {
				BackgroundBus.pub("ActiveWorkbook", "workbookUnavailable", true);
			} else {
				BackgroundBus.pub("ActiveWorkbook", "workbookAvailable", true);
			}
		},
		pageTitle(pageTitle) {
			if (pageTitle.length > 0) {
				document.title = pageTitle;
			}
		},
		activeSheetView(activeSheetView) {

			const vcSelf = this;

			// Since the sheetView has changed, reset the sidebar state
			vcSelf.sidebarTab = null;

			// console.log(`activeSheetView`, activeSheetView, this.firstSheetView);
			window.activeSheetView = activeSheetView;

			BackgroundBus.pub("ActiveWorkbook", "sheetViewAvailable", activeSheetView);
			if (!activeSheetView && vcSelf.sheetViewGUID && vcSelf.firstSheetView && vcSelf.firstSheetView.$internals.metaProperties.meta.activeLevel === 0) {
				// console.log("D");
				// vcSelf.$router.replace(`/sheets/${vcSelf.dataStoreGUID}/${vcSelf.firstSheetView.$internals.metaProperties.meta.guid}`);

				vcSelf.$router.replace({
					name: 'sheet-details-view',
					params: {
						dataStoreGUID: vcSelf.dataStoreGUID,
						sheetViewGUID: vcSelf.firstSheetView.$internals.metaProperties.meta.guid
					}
				});

			}
			else if (!activeSheetView) {
				// console.log("E");
				vcSelf.$router.replace(`/sheets/${vcSelf.dataStoreGUID}/`);
			}

			// always clear the props before we open another configurator
			vcSelf.configuratorProps = null;

			if (activeSheetView && activeSheetView.type !== 'table' && this.workbookHasPermission('view_changeDateColumns')) {
				vcSelf.$nextTick(function afterConfiguratorModalClosed() {
					let sheetConfig = activeSheetView.getOrCreateDisplayConfigurator();
					if (activeSheetView.type === 'gantt' && !activeSheetView.ganttIsValid().isValid) {
						if (sheetConfig.dateLastConfigured === null) {
							// never configured, guide them through the flow
							vcSelf.configuratorProps = {
								sheetView: activeSheetView,
								tabFlow: true,
							};
						}
						else {
							vcSelf.configuratorProps = {
								sheetView: activeSheetView,
								initialTab: 'plottedData',
								tabFlow: false,
								fixProblem: true,
							};
						}
					}
					else if (activeSheetView.type === 'timeline' && !activeSheetView.timelineIsValid().isValid) {
						if (sheetConfig.dateLastConfigured === null) {
							// never configured, guide them through the flow
							vcSelf.configuratorProps = {
								sheetView: activeSheetView,
								tabFlow: true,
							};
						}
						else {
							vcSelf.configuratorProps = {
								sheetView: activeSheetView,
								initialTab: 'plottedData',
								tabFlow: false,
								fixProblem: true,
							};
						}
					}
				});
			}
			// Everytime we change the sheetview, this sharedSheetState gets cleared out
			this.sharedSheetState = new ReactiveVueObject();
		},
		orosImpactingDataStoreToBePublished(orosToPublish) {
			for (let oroIndex in orosToPublish) {
				this.$pubsub.modules.oros.pub('oroForDataStoreArrived', {
					oro: orosToPublish[oroIndex],
				});
				this.orosPublished.push(orosToPublish[oroIndex]);
				// console.log(`Publishing ORO that arrived: `, orosToPublish[oroIndex]);
			}
		},
		workbookState: {
			immediate: true,
			handler(newState) {
				if (this.$pubsub) {
					this.$pubsub.modules.workbookState.pub('stateChanged', newState);
				}
			}
		},
		dataStoreGUID: {
			immediate: true,
			handler(dataStoreGUID, previousDataStoreGUID) {
				const vcSelf = this;

				if (previousDataStoreGUID) {
					// get a fresh data state
					vcSelf.$emit('reload');
				}

				vcSelf.firstSheetView = null;

				// GlobalModules.CloudStore.load({
				// 	filters:{
				// 		context:{
				// 			user_guid: false,
				// 			team_guid: false,
				// 			org_guid: false,
				// 			core_context: false,
				// 		},
				// 		meta:{
				// 			type:{
				// 				eq:"WorkbookOperationMessage",
				// 			}
				// 		}
				// 	},
				// 	linkedObjects:{
				// 		depth: 1,
				// 	}
				// }, function withWOMS(woms){
				// 	console.log(woms);
				// 	window.woms = woms;
				// });
				// This connected app list should be smart to just load in the ones that are relevant to the workbook
				//If the dataStore was just created, this won't work, so we need to also account for that possibility
				CloudStore.load({
					filters: {
						context: {
							user_guid: false,
							team_guid: false,
							core_context: false,
						},
						meta: {
							guid: {
								eq: dataStoreGUID,
							}
						}
					},
					linkedObjects: {
						includes: [{
							filters: {
								edges: {
									name: {
										eq: 'meta',
									}
								},
								meta: {
									type: {
										eq: 'DataStoreMeta'
									}
								}
							},
							linkedObjects: {
								includes: [{
									filters: {
										edges: {
											name: {
												eq: 'schema',
											}
										},
										meta: {
											type: {
												eq: "Schema",
											}
										}
									}
								}, {
									filters: {
										edges: {
											name: {
												eq: 'dataStoreWizard',
											}
										},
										meta: {
											type: {
												eq: "DataStoreWizard",
											}
										}
									}
								}]
							}
						}],
						inboundIncludes: [{
							filters: {
								edges: {
									name: {
										eq: "dataStore"
									}
								},
								meta: {
									type: {
										eq: 'SheetViewGroup'
									}
								}
							},
							linkedObjects: {
								inboundIncludes: [{
									filters: {
										edges: {
											name: {
												eq: "sheetViewGroup"
											}
										},
										meta: {
											type: {
												eq: 'SheetView'
											}
										}
									},
									options: {
										limit: 500,
									}
								}]
							}
						}, {
							filters: { //Temporary
								edges: {
									name: {
										eq: 'dataStore',
									},
								},
								meta: {
									type: {
										eq: 'DataStoreComment',
									}
								}
							},
							linkedObjects: {
								depth: 1,
							},
						}, {
							filters: { //Temporary -- should be split out to improve perf on large workbooks
								edges: {
									type: {
										eq: 'dataStoreImpacted',
									}
								},
								meta: {
									type: {
										eq: 'WorkbookOperationMessage',
									}
								},
								payload: {
									isOpen: {
										eq: true,
									}
								}
							}
						}]
					}
				}, function withResult(baseObjects) {
					if (baseObjects) {
						if (baseObjects[0]) {
							BackgroundBus.pub("ActiveWorkbook", "dataStoreAvailable", baseObjects[0]);
							vcSelf.sheetGlobalState.dataStore = baseObjects[0];
							vcSelf.loading = false;
							// load the records here
							vcSelf.loadRecordsFromDataStore(baseObjects[0]);
							// load the OROs here
							vcSelf.loadOROsFromDataStore(baseObjects[0]);
						} else {
							//Do this because maybe we just made the DataStore and it's local but not on the server ... this gets a CSO by guid from the Accountant
							CloudStore.get(vcSelf.dataStoreGUID, function withObjectBack(csoDataStoreBack) {
								if (csoDataStoreBack) {
									BackgroundBus.pub("ActiveWorkbook", "dataStoreAvailable", csoDataStoreBack);
									vcSelf.sheetGlobalState.dataStore = csoDataStoreBack;
									vcSelf.loading = false;
									vcSelf.failedLoading = false;
								} else {
									// Assert.throwError(`Unable to load csoGUID from server or locally`);
									vcSelf.sheetGlobalState.dataStore = null;
									vcSelf.loading = false;
									vcSelf.failedLoading = true;
								}
							});
						}
					}
				});
			}
		},
		dataStoreRecordsByLevels: {
			immediate: true,
			handler(newValue) {
				if (this.sheetGlobalState.dataStore) {
					this.sheetGlobalState.dataStoreRecordsByLevels = newValue;
					BackgroundBus.pub("ActiveWorkbook", "dataStoreRecordsByLevelAvailable", newValue);
				}
			}
		},
	},
	components: {
		GlobalStateAggregatorOro,
		GlobalStateAggregatorWom,
		ReactiveReferences,
		ViewFooterRoot,
		SheetViewSidebar(){
			return import(/* webpackChunkName: "sheet-view-sidebar" */ 'vue/sheet-views/common/sidebar/sheet-view-sidebar.vue');
		},
		SheetWizardConductor() {
			return import(/* webpackChunkName: "sheet-wizard-conductor" */ 'vue/sheet-views/common/onboarding/sheet-wizard-conductor.vue');
		},
		SheetWizardRenderer() {
			return import(/* webpackChunkName: "sheet-wizard-renderer" */ 'vue/sheet-views/common/onboarding/sheet-wizard-renderer.vue');
		},
		ExportBottomBar(){
			return import(/* webpackChunkName: "export-bottom-bar" */ 'vue/import-export/export-bottom-bar.vue');
		}
	},
	props: {
		dataStoreGUID: {
			required: true,
			type: String,
		},
		sheetViewGUID: {
			required: false,
			type: String,
		}
	},
	computed: {
		/**
		 * Verify that the license manager is available
		 */
		isLicenseManagerAvailable() {
			return this.$root.systemState.licenseManager !== undefined && this.$root.systemState.licenseManager.isAvailable()
				? true
				: false;
		},
		activeSheetView() {
			if (this.sheetGlobalState.dataStore && this.sheetViewGUID) {
				return this.sheetGlobalState.dataStore.getSheetViewByGUID(this.sheetViewGUID)
			}
			return null;
		},
		activeSheetViewType() {
			if (this.activeSheetView) {
				return this.activeSheetView.type;
			}
		},
		bodyComponent() {
			if (this.activeSheetViewType) {
				return vueComponentsByType[this.activeSheetViewType].body;
			}
		},
		workbookPermissionCache() {
			if (this.sheetGlobalState.dataStore) {
				return this.sheetGlobalState.dataStore.bulkGetPermissions();
			}
			return {};
		},
		canViewWorkbook() {
			if (this.sheetGlobalState.dataStore) {
				return this.workbookHasPermission('access_view');
			}
			else if(this.failedLoading){
				return false;
			}
			else {
				return true;
			}
		},
		orosImpactingDataStore() {
			if (this.sheetGlobalState.dataStore) {
				return this.sheetGlobalState.dataStore.$internals.inboundEdges.object.OperationRequestObject.name['operationBody.externalOperationParams.dataStore'].map(function getOroFromEdge(edge) {
					return edge.from;
				});
			}
			else {
				return [];
			}
		},
		orosImpactingDataStoreToBePublished() {
			const vcSelf = this;
			return vcSelf.orosImpactingDataStore.filter(function oroHasBeenPublished(oro) {
				return vcSelf.orosPublished.indexOf(oro) < 0;
			})
		},
		pageTitle() {
			let title = 'Visor';
			if (this.sheetGlobalState.dataStore) {
				title += ` - ${this.sheetGlobalState.dataStore.title}`;

				if (this.activeSheetView) {
					title += ` - ${this.activeSheetView.title}`;
				}
			}
			return title;
		},
		systemStateExperience() {
			return this.$root.systemState.experience;
		},
		shouldShowWizard() {
			return this.activeSheetView && OnboardingUtils.shouldShowOnboardingWizard(this.systemStateExperience, this.sheetGlobalState.dataStore);
		},
		globalModalIsOpen(){ //targeted to help us understand if the upsell modal is open
			return this.$root.systemState.interface.modals.modalsOpen.includes('global');
		},
		TimelineRecordModalComponent() {
			return TimelineRecordModal;
		},
		WelcomeGuideHelperModalComponent() {
			return WelcomeGuideHelperModal;
		},
		NewColumndModalComponent() {
			return NewColumnModal;
		},
		DropdownOptionsModalComponent() {
			return DropdownOptionsModal;
		},
		FilterColumnsModalComponent() {
			return FilterColumnsModal;
		},
		VersionHistoryModal() {
			return VersionHistoryModal;
		},
		AccessControlModal() {
			return AccessControlModal;
		},
		ConfiguratorContainerModalComponent() {
			return ConfiguratorContainerModal;
		},
		PrimaryColumnModalComponent() {
			return PrimaryColumnModal;
		},
		IntegrationManagementModal() {
			return IntegrationManagementModal;
		},
		clearTableModalComponent(){
			return ClearTableModal;
		},
		importDataModalComponent(){
			return ImportDataModal;
		},
		EmbedModalComponent(){
			return EmbedModal;
		},
		windowHeight() {
			return this.$root.systemState.window.height;
		},
		windowWidth() {
			return this.$root.systemState.window.width;
		},
		workbookState() {
			return {
				workbook: this.sheetGlobalState.dataStore,
				activeSheetView: this.activeSheetView,
			};
		},
		dataStoreRecordsByLevels() {
			if (this.sheetGlobalState.dataStore && this.sheetGlobalState.dataStore.meta && this.sheetGlobalState.dataStore.meta.schema) {
				return this.sheetGlobalState.dataStore.getRecordsByLevels();
			}
			return [];
		},
		queryNew() {
			return this.$route.query.new === '1';
		},
	},
	methods: {
		loadRecordsFromDataStore(dataStore) {
			const vcSelf = this;
			CommonVueFunctions.methods.runRecordLoad.apply(vcSelf, [dataStore]);
		},
		loadOROsFromDataStore(dataStore) {
			CommonVueFunctions.methods.runOROLoad.apply(this, [dataStore]);
		},
		closeWelcomeHelper(closeDetails) {
			if (!closeDetails || closeDetails.source !== 'shroud') {
				if (this.welcomeGuideHelperProps.onClose) {
					this.welcomeGuideHelperProps.onClose();
				}
				this.welcomeGuideHelperProps = null;
			}
		},
		closeDropdownOptionsModal(closeDetails) {
			if (!closeDetails || closeDetails.source !== 'shroud') {
				this.dropdownOptionsProps = null
			}
		},
		workbookHasPermission(accessRequestKey) {
			if (this.sheetGlobalState.dataStore) {
				let cachedPermissions = this.workbookPermissionCache;
				if (cachedPermissions) {
					return cachedPermissions[accessRequestKey];
				}
				else {
					return this.sheetGlobalState.dataStore.hasPermission(accessRequestKey);
				}
			}
			else {
				Assert.throwError('Tried to get permission before workbook loaded');
			}
		},
		exportBottomBarMounted(){
			if(this.exportBottomBarMountCallback){
				this.exportBottomBarMountCallback();
			}
			this.exportBottomBarMountCallback = null;
		},
		exportBottomBarBeforeDestroy(){
			this.exportBottomBarMountCallback = null;
		},
	}
};

</script>

<style scoped lang="scss">
.no-permission-outter {
	@include flex(row, center);

	position: relative;
	width: 100%;
	height: 100%;

	.no-permission-container {
		cursor: default;
		width: 264px;
		padding: 18px;
		border: 1px solid $p-color-grey-300;
		box-sizing: border-box;
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
		border-radius: 3px;

		background-color: $p-color-white;

		.no-permission-title {
			color: $p-color-grey-600;
			margin-bottom: 6px;
		}

		.no-permission-body {
			color: $p-color-grey-500;
		}
	}
}

.sheet-details-outter {
	width: 100%;
	height: 100%;
}

.sheet-view-body {
	width: 100%;
	height: 100%
}

.sheet-view-footer {
	width: 100%;
	height: 100%;

	// z-index: 1000;

	&.raise-config {
		z-index: 100001;
	}
}
</style>